module.exports = __webpack_public_path__ + "media/images/nav-e6ca23e796ba20b79314faf196860cfa.svg";